import type { FC } from 'react';

import Text from '@/components/Text';
import githubLanguageColors from '@/config/githubColors.json';

type Props = { languages: [string, number][] };

const RepositoryLanguages: FC<Props> = ({ languages }) => {
  const numberOfAllLines = languages.reduce(
    (accumulator, [, numberOfLines]) => accumulator + numberOfLines,
    0
  );
  const convertedLanguagesList = languages
    .sort((a, b) => b[1] - a[1])
    .map(
      ([language, lines]) =>
        [language, Math.round((lines / numberOfAllLines) * 100 * 10) / 10] as [
          string,
          number
        ]
    );
  return (
    <div className="flex flex-col gap-1">
      {convertedLanguagesList.length <= 0 && (
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="h-2 w-2 rounded-full bg-neutral-300" />
            <Text variant="body-caption" className="text-neutral-300">
              No languages detected
            </Text>
          </div>
        </div>
      )}
      {convertedLanguagesList.map(([language, numberOfLines]) => (
        <div key={language} className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div
              className="h-2 w-2 rounded-full"
              style={{
                backgroundColor:
                  (githubLanguageColors as { [key: string]: string })[
                    language.toLowerCase()
                  ] ?? '#000000',
              }}
            />
            <Text variant="body-caption" className="text-neutral-300">
              {language}
            </Text>
          </div>
          <Text variant="body-caption" className="text-neutral-300">
            {numberOfLines}%
          </Text>
        </div>
      ))}
    </div>
  );
};

export default RepositoryLanguages;
